import {
  Box,
  IconButton,
  Typography,
} from '@material-ui/core'
import PropTypes from 'prop-types'

const Dialpad = (props) => {
  const { sendDigits } = props
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', pl: 1, pb: 1 }}>
        <IconButton onClick={() => sendDigits('1')}>
          <Box sx={{ width: 33, height: 33 }}>
            <Typography variant="h5">
              1
            </Typography>
          </Box>
        </IconButton>
        <IconButton onClick={() => sendDigits('2')}>
          <Box sx={{ width: 33, height: 33 }}>
            <Typography variant="h5">
              2
            </Typography>
            <Typography variant="body2">
              ABC
            </Typography>
          </Box>
        </IconButton>
        <IconButton onClick={() => sendDigits('3')}>
          <Box sx={{ width: 33, height: 33 }}>
            <Typography variant="h5">
              3
            </Typography>
            <Typography variant="body2">
              DEF
            </Typography>
          </Box>
        </IconButton>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', pl: 1, pb: 1 }}>
        <IconButton onClick={() => sendDigits('4')}>
          <Box sx={{ width: 33, height: 33 }}>
            <Typography variant="h5">
              4
            </Typography>
            <Typography variant="body2">
              GHI
            </Typography>
          </Box>
        </IconButton>
        <IconButton onClick={() => sendDigits('5')}>
          <Box sx={{ width: 33, height: 33 }}>
            <Typography variant="h5">
              5
            </Typography>
            <Typography variant="body2">
              JKL
            </Typography>
          </Box>
        </IconButton>
        <IconButton onClick={() => sendDigits('6')}>
          <Box sx={{ width: 33, height: 33 }}>
            <Typography variant="h5">
              6
            </Typography>
            <Typography variant="body2">
              MNO
            </Typography>
          </Box>
        </IconButton>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', pl: 1, pb: 1 }}>
        <IconButton onClick={() => sendDigits('7')}>
          <Box sx={{ width: 33, height: 33 }}>
            <Typography variant="h5">
              7
            </Typography>
            <Typography variant="body2">
              PQRS
            </Typography>
          </Box>
        </IconButton>
        <IconButton onClick={() => sendDigits('8')}>
          <Box sx={{ width: 33, height: 33 }}>
            <Typography variant="h5">
              8
            </Typography>
            <Typography variant="body2">
              TUV
            </Typography>
          </Box>
        </IconButton>
        <IconButton onClick={() => sendDigits('9')}>
          <Box sx={{ width: 33, height: 33 }}>
            <Typography variant="h5">
              9
            </Typography>
            <Typography variant="body2">
              WXYZ
            </Typography>
          </Box>
        </IconButton>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', pl: 1, pb: 1 }}>
        <IconButton onClick={() => sendDigits('*')}>
          <Box sx={{ width: 33, height: 33 }}>
            <Typography variant="h5">
              *
            </Typography>
          </Box>
        </IconButton>
        <IconButton onClick={() => sendDigits('0')}>
          <Box sx={{ width: 33, height: 33 }}>
            <Typography variant="h5">
              0
            </Typography>
          </Box>
        </IconButton>
        <IconButton onClick={() => sendDigits('#')}>
          <Box sx={{ width: 33, height: 33 }}>
            <Typography variant="h5">
              #
            </Typography>
          </Box>
        </IconButton>
      </Box>
    </>
  )
}

Dialpad.propTypes = {
  sendDigits: PropTypes.any
}

export default Dialpad
